"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var a = (0, _taggedTemplateLiteral2["default"])(["\n  query GetAssetSummariesAndCount(\n    $organisationId: String, \n    $search: String, \n    $isArchived: Boolean,\n    $assetFileTypes: [Type],\n    $offset: Int, \n    $limit: Int\n    ) {\n    getAssetSummariesAndCount(\n      organisationId: $organisationId, \n      search: $search, \n      isArchived: $isArchived,\n      assetFileTypes: $assetFileTypes,\n      offset: $offset, \n      limit: $limit\n      ) {\n      count\n      assets {\n        assetId\n        organisationId\n        filename\n        title\n        description\n        altText\n        metaData\n        updatedAt\n        permissions\n        updatedByUser {\n          firstName,\n          lastName\n        }\n        assetFiles {\n          ORIGINAL {\n            assetFileId\n            type\n            status\n            sourceUrl\n          }\n          THUMBNAIL {\n            assetFileId\n            type\n            status\n            sourceUrl\n          }\n        }\n      }\n    }\n  }\n"]);
  return _templateObject = function _templateObject() {
    return a;
  }, a;
}

var getAssetSummariesAndCount = (0, _graphqlTag["default"])(_templateObject()),
    _default = function _default(a) {
  return {
    query: getAssetSummariesAndCount,
    module: "assets",
    ignoreCache: !0,
    buildVariables: function buildVariables(b) {
      var c = b.offset,
          d = b.limit,
          e = b.search,
          f = b.isArchived;
      return {
        organisationId: a,
        limit: d,
        offset: c,
        search: e,
        isArchived: f,
        assetFileTypes: ["THUMBNAIL"]
      };
    }
  };
};

exports["default"] = _default;